import { ApiManager } from 'utlis/api_manager';

const api = new ApiManager(process.env.REACT_APP_BASE_URL, 1);

export default class JobsService {
  /**
   * Create a new async job.
   * @param {string} type - Job type, e.g. "video_frame_extraction"
   * @param {object} inputPayload - Job input, e.g. { video_url: "..." }
   * @returns {Promise<{job_id: string, status: string}>}
   */
  static async createJob(type, inputPayload, signal) {
    const { data } = await api.setUrl('project/background-jobs').post({
      type,
      input_payload: inputPayload,
    }, { signal });

    return data;
  }

  /**
   * Get the status of an existing job.
   * @param {string} jobId
   * @returns {Promise<{id: string, type: string, status: string, output_payload: object, error: string|null}>}
   */
  static async getJobStatus(jobId) {
    if (!jobId) {
      throw new Error('jobId is required to fetch job status');
    }

    const { data } = await api.setUrl(`project/background-jobs/${jobId}`).get();

    return data;
  }
}
